import { render, staticRenderFns } from "./CertificateList.vue?vue&type=template&id=6af3823c&scoped=true"
import script from "./CertificateList.vue?vue&type=script&lang=js"
export * from "./CertificateList.vue?vue&type=script&lang=js"
import style0 from "./CertificateList.vue?vue&type=style&index=0&id=6af3823c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3823c",
  null
  
)

export default component.exports